export const AT_AUTO_BACKUPS_UPDATE_ACTION = 'AUTO_BACKUPS_UPDATE_ACTION';
export const AT_AUTO_BACKUPS_ADD_ACTION = 'AUTO_BACKUPS_ADD_ACTION';
export const AT_AUTO_BACKUPS_IS_LOADING_SET = 'AUTO_BACKUPS_IS_LOADING_SET_ACTION';
